import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import WhereToWatch from '../components/WhereToWatch/WhereToWatch';

import getAffiliateIdUrl from '../../utils/getAffiliateIdUrl';
import getAudioUrl from '../../utils/getAudioUrl';
import getTvUrl from '../../utils/getTvUrl';
import { getWhereToWatchData } from '../../utils/getWhereToWatchData';
import { buttonDisplayFormatConfig } from '../../utils/productButtonConfigs';

const WhereToWatchContainer = (props) => {
    const {
        gamePk,
        gameDate,
        locale,
        env,
        urlRoot,
        cardType,
        fetchData,
        setFetchData
    } = props;
    const displayFormatConfig = buttonDisplayFormatConfig[cardType];
    const { affiliateId } = displayFormatConfig;

    const [modalOpen, setModalOpen] = useState(false);
    const [whereToWatchData, setWhereToWatchData] = useState(null);

    const tvLink = useMemo(() => {
        return getAffiliateIdUrl(getTvUrl(urlRoot, gamePk, gameDate), affiliateId, true);
    }, [gamePk, urlRoot, gameDate, cardType]);

    useEffect(() => {
        async function getData () {
            if (fetchData) {
                const result = await getWhereToWatchData({ gamePk, gameDate, locale, env });
                if (!result) {
                    setFetchData(false); // this shouldn't be necessary, but to be safe
                    window.location.href = tvLink;
                    return false;
                }
                setWhereToWatchData(result);
                setModalOpen(true);
            }
        }
        getData();
    }, [fetchData, tvLink, gamePk, gameDate, locale]);

    const audioLink = useMemo(() => {
        const { callLetters } = whereToWatchData ?? {};
        return callLetters ? getAffiliateIdUrl(getAudioUrl(urlRoot, gamePk, callLetters), affiliateId, true) : null;
    }, [gamePk, urlRoot, whereToWatchData, cardType]);

    useEffect(() => {
        if (!modalOpen) {
            setFetchData(false);
        }
    }, [modalOpen]);

    if (!whereToWatchData || Object.keys(whereToWatchData).length === 0) {
        return null;
    }

    return (
        <WhereToWatch
            isOpen={modalOpen}
            setIsOpen={setModalOpen}
            watchData={whereToWatchData}
            tvLink={tvLink}
            audioLink={audioLink}
            {...props}
        />
    );
};

WhereToWatchContainer.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    watchData: PropTypes.object,
    dictionary: PropTypes.object,
    gamePk: PropTypes.number,
    urlRoot: PropTypes.string,
    gameDate: PropTypes.string,
    cardType: PropTypes.string,
    locale: PropTypes.string,
    env: PropTypes.string,
    fetchData: PropTypes.bool,
    setFetchData: PropTypes.func
};

export default WhereToWatchContainer;
